import { IActivityItemBase } from '../../models/activities';
import { IBookingBase } from '../../models/bookings';
import wbsBookingsApi from '../apis/wbsBookingsApi';

interface ICreateBookingProps {
  activityScheduleId: string;
  bookedDate: Date;
  bookingQueueId?: string;
  description?: string;
  endTime?: Date;
  isActive?: boolean;
  isVerified?: boolean;
  items?: IActivityItemBase[];
  notificationTimers?: number[];
  sendCreateNotification?: boolean;
  skipLimits?: boolean;
  startTime?: Date;
  userId: string;
}

export type INewBooking = IBookingBase;

export const createBookingsService = async ({
  activityScheduleId,
  bookedDate,
  bookingQueueId,
  description,
  endTime,
  isActive,
  isVerified,
  items,
  notificationTimers,
  sendCreateNotification,
  skipLimits,
  startTime,
  userId,
}: ICreateBookingProps): Promise<INewBooking> => {
  const { data } = await wbsBookingsApi.post<INewBooking>(
    '/bookings',
    {
      activityScheduleId,
      bookedDate,
      bookingQueueId,
      description,
      endTime,
      isActive,
      items,
      notificationTimers,
      sendCreateNotification,
      startTime,
      userId,
    },
    { params: { isVerified, skipLimits } },
  );

  return data;
};
